export const validHTML = (htmlString: string): boolean => {
  const parser = new DOMParser();

  try {
    const doc = parser.parseFromString(htmlString, 'text/html');

    if (doc.documentElement.nodeName === 'parsererror') {
      return false;
    } else {
      return true;
    }
  } catch (_error) {
    return false;
  }
};
